import { useEffect } from "react";
import { Form, Input, Select, Row, Col } from "antd";
import "../roles/addRole.css";
import secureLocalStorage from "react-secure-storage";
import { useDispatch } from "react-redux";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";
import { submitRoleThunk } from "../../../store/thunks/rolesThunk";

const { Option } = Select;

const AddRole = ({ editData, statuses, sections, onSuccess, children }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  /*begin::call to api for creating new role*/
  const onSubmit = async (values, editData) => {
    const isEdit = Boolean(editData);
    const payload = {
      name: values?.name,
      sections: values?.sections,
      status: isEdit ? values.status : "ACTIVE",
      historySource: "backend",
      historyAction: isEdit ? "update" : "create",
      historyUserID: slsLIUId,
    };

    if (isEdit) {
      payload.id = editData.key;
    }

    await dispatch(submitRoleThunk(payload)).unwrap();
  };

  useEffect(() => {
    if (!editData || sections.length === 0) return;

    const sectionValue =
      editData.sections?._id ||
      editData.sections ||
      editData.sections?.[0]?._id ||
      null;

    form.setFieldsValue({
      name: editData.name,
      sections: sectionValue,
      status: editData.status,
    });
  }, [editData, sections]);

  /*end::call to api for creating new role*/

  return (
    <>
      <AddEditForm
        form={form}
        editData={editData}
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        successMessages={{
          create: "Role created successfully",
          update: "Role updated successfully",
        }}
        fields={
          <>
            <Row className="pb-16" gutter={[12, 12]}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please enter the name!" },
                  ]}
                >
                  <Input placeholder="Enter name" className="w-100" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  className="m-0"
                  label="Sections"
                  name="sections"
                  rules={[
                    {
                      required: true,
                      message: "Please enter section",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    size="large"
                    className="rounded-md h-45px rounded-md"
                    isclearable="true"
                    mode="multiple"
                    placeholder="Select Section"
                    options={sections}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        ?.toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              {editData && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label="Status"
                    name="status"
                    rules={[
                      { required: true, message: "Please select a status!" },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      options={statuses}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      placeholder="Select Status"
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </>
        }
      />
    </>
  );
};
export default AddRole;
